import React, { useState } from "react";
import { Layout  } from "antd";
import "./app.css";
import TopicMenu from "./TopicMenu";
import NavBar from "./Navbar";
import SideBar from "./sidebar";
import Login from '../Components/Login'
import Home from '../Components/Home'
import ParentAll from '../Components/Parents/allstudent'
import ParentRequest from '../Components/Parents/request'
import RMAll from '../Components/RMs/allrm'
import RMAudit from '../Components/RMs/audit'
import RMRating from '../Components/RMs/rating'
import RMRecords from '../Components/RMs/records'
import RMAttendance from '../Components/RMs/attendance'
import OperationEng from "../Components/Operations/eng";
import OperationMaths from "../Components/Operations/math";
import UploadStudent from "../Components/Upload/student";
import UploadRM from "../Components/Upload/rm";
import UploadResponse from "../Components/Upload/response";

function App() {
  const topics = ["Login-Login","Home-Home", "Parent-AllStudents","Parent-Request","CR-AllCR", "CR-Audit","CR-Rating","CR-Old Records","CR-Attendance","Operations-Math","Operations-English","UploadFile-Student","UploadFile-CR","UploadFile-Response"];
  const [contentIndex, setContentIndex] = useState(0);
  const [selectedKey, setSelectedKey] = useState("0");

  const changeSelectedKey = (event) => {
    const key=topics.findIndex((obj)=>obj===`${event.keyPath[1]}-${event.keyPath[0]}`)
    // const key = event.key;
    setSelectedKey(key);
    setContentIndex(+key);
  };

  const Menu = (
    <TopicMenu
      topics={topics}
      selectedKey={selectedKey}
      changeSelectedKey={changeSelectedKey}
    />
  );
  
  return (
    <div className="App">
      <NavBar menu={Menu} />
      <Layout>
        <SideBar menu={Menu}  changeSelectedKey={changeSelectedKey}/>
        <Layout.Content className="content">
          {/* {topics[contentIndex]} */}
          {contentIndex===0?
            <Login/>
          :
            contentIndex===1?
            <Home/>
            :
            contentIndex===2?
            <ParentAll/>
            :
            contentIndex===3?
            <ParentRequest/>
            :
            contentIndex===4?
            <RMAll/>
            :
            contentIndex===5?
            <RMAudit/>
            :
            contentIndex===6?
            <RMRating/>
            :
            contentIndex===7?
            <RMRecords/>
            :
            contentIndex===8?
            <RMAttendance/>
            :
            contentIndex===9?
            <OperationMaths/>
            :
            contentIndex===10?
            <OperationEng/>
            :
            contentIndex===11?
            <UploadStudent/>
            :
            contentIndex===12?
            <UploadRM/>
            :
            <UploadResponse/>
          }
        </Layout.Content>
      </Layout>
    </div>
  );
}
export default App;

